const PHOTO_URL = '/assets/samba.jpg';

export const About = () => {
  return (
    <section data-testid="about" className="px-5 md:px-8 py-6 md:py-12 bg-hda-bg">
      <div className="max-w-4xl mx-auto flex flex-col gap-6">
        <p className="microlabel text-center md:text-left">Qui je suis</p>

        <div className="flex flex-col md:flex-row md:items-start gap-6 md:gap-10">
          <div
            className="mx-auto md:mx-0 shrink-0 overflow-hidden"
            style={{
              width: '100%',
              maxWidth: 420,
              aspectRatio: '4 / 5',
              borderRadius: 16,
            }}
          >
            <img
              src={PHOTO_URL}
              alt="Samba, fondateur de Hustler Digital Academy"
              loading="lazy"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center 40%',
                display: 'block',
              }}
            />
          </div>

          <div
            className="flex-1 text-[#F5EFE3]/85"
            style={{ fontSize: 16, lineHeight: 1.6, maxWidth: 520 }}
          >
            <p style={{ marginBottom: 18 }}>
              Je m&rsquo;appelle{' '}
              <span className="font-serif text-[#F5EFE3]" style={{ fontSize: 17 }}>
                Samba
              </span>
              , j&rsquo;ai 22 ans. Et entre mes 17 et 22 ans, j&rsquo;ai tout essayé&nbsp;: e-commerce, trading, SMMA, crypto, affiliation. J&rsquo;ai échoué partout. Puis un jour, j&rsquo;ai découvert le vrai business qui se cache derrière la réussite de 99% des gens qui gagnent de l&rsquo;argent en ligne. Grâce à ça, j&rsquo;ai généré{' '}
              <span className="font-serif text-[#E8D9AA]" style={{ fontSize: 17 }}>
                54&nbsp;491€
              </span>{' '}
              depuis ma chambre — sans diplôme et sans compétence particulière.
            </p>
            <p style={{ marginBottom: 0 }}>
              Aujourd&rsquo;hui, j&rsquo;accompagne des élèves de 18 à 30 ans. Certains partent de zéro, sans aucune compétence. D&rsquo;autres avaient déjà un business qui leur rapportait moins de 5&nbsp;000€ par mois. Notre objectif&nbsp;: leur faire atteindre 5&nbsp;000€ par mois en 90 jours grâce à notre méthode, la HDA.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
